import React from 'react';

interface TextShimmerProps {
  children: React.ReactNode;
  className?: string;
}

export const TextShimmer: React.FC<TextShimmerProps> = ({ children, className = '' }) => {
  return (
    // Contraste fort et volontairement visible : une bande quasi-noire (grey-900)
    // balaie un texte gris moyen (grey-500). L'ancien dégradé grey-600↔grey-400
    // (highlight plus CLAIR que la base) se voyait à peine ; ici la base est plus
    // claire que la bande qui la traverse → le balayage sombre « pulse » nettement,
    // signalant sans ambiguïté que réflexion / outils / sous-agents sont EN COURS.
    <span
      className={`inline-block bg-gradient-to-r from-grey-500 via-grey-900 to-grey-500 bg-[length:200%_100%] bg-clip-text text-transparent animate-shimmer ${className}`}
      style={{
        animation: 'shimmer 1.6s linear infinite',
      }}
    >
      {children}
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </span>
  );
};
